<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <h5 class="modal-title" i18n>Edit Rental Taxes</h5>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase">
          <span class="fal fa-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fal fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div formArrayName="taxes" *ngFor="let item of taxes.controls; let i = index">
          <div [formGroupName]="i" class="row container-box">
            <div class="col-sm-1">
              <button (click)="removeTax(i)" class="remove-tax tax-btn" type="button">
                <i class="fal fa-minus"></i>
              </button>
            </div>
            <div class="col-sm-2">
              <ng-select
                #tax
                [items]="availableTaxes"
                bindLabel="name"
                [addTag]="newTaxName"
                [addTagText]="'Add Tax'"
                [hideSelected]="true"
                [clearable]="false"
                [multiple]="false"
                placeholder="Name"
                i18n-placeholder
                appendTo="body"
                formControlName="name"
                (change)="onAccountTaxSelected($event, item)"
                required
              >
              </ng-select>
              <mat-error
                *ngIf="item['controls'].name.touched && item.hasError('required', ['name'])"
                style="margin-top: -12px"
                i18n
              >
                Name is required
              </mat-error>
            </div>
            <div class="col-sm-2">
              <mat-form-field class="mat-block">
                <mat-label
                  ><span [innerHtml]="item['controls'].type.value | amountPlaceholder : currencySymbol"></span
                ></mat-label>
                <input type="number" min="0" formControlName="amount" required matInput />
                <mat-error *ngIf="item['controls'].amount.touched && item.hasError('required', ['amount'])" i18n>
                  Amount is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-2">
              <mat-form-field class="mat-block">
                <mat-select formControlName="type" placeholder="Amount Type" i18n-placeholder>
                  <mat-option value="percent" i18n>Percent</mat-option>
                  <mat-option value="flat" i18n>Flat</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-2">
              <mat-form-field class="mat-block">
                <mat-select formControlName="tax_type" placeholder="Tax Type" i18n-placeholder required>
                  <mat-option value="pass_through_hotel_tax" i18n>Hotel Tax</mat-option>
                  <mat-option value="pass_through_lodging_tax" i18n>Lodging Tax</mat-option>
                  <mat-option value="pass_through_room_tax" i18n>Room Tax</mat-option>
                  <mat-option value="pass_through_tourist_tax" i18n>Tourist Tax</mat-option>
                  <mat-option value="pass_through_transient_occupancy_tax" i18n>Transient Occupancy Tax</mat-option>
                  <mat-option value="pass_through_sales_tax" i18n>Sales Tax</mat-option>
                  <mat-option value="pass_through_vat_gst" i18n>VAT / GST</mat-option>
                  <mat-option value="pass_through_tourism_assessment_fee" i18n>Tourism Assessment Fee</mat-option>
                </mat-select>
                <mat-error *ngIf="item['controls'].tax_type.touched && item.hasError('required', ['tax_type'])" i18n>
                  Tax Type is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field class="mat-block">
                <mat-select formControlName="modality" placeholder="Modality" i18n-placeholder>
                  <mat-option [value]="taxV3Modalities.PerStay">{{
                    taxV3ModalityLabels[taxV3Modalities.PerStay]
                  }}</mat-option>
                  <mat-option [value]="taxV3Modalities.PerNight">{{
                    taxV3ModalityLabels[taxV3Modalities.PerNight]
                  }}</mat-option>
                  <mat-option [value]="taxV3Modalities.PerPerson">{{
                    taxV3ModalityLabels[taxV3Modalities.PerPerson]
                  }}</mat-option>
                  <mat-option [value]="taxV3Modalities.PerPersonPerNight">{{
                    taxV3ModalityLabels[taxV3Modalities.PerPersonPerNight]
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!--            <div class="col-sm-1"></div>-->
            <!--            <div class="col-sm-4">-->
            <!--              <mat-form-field class="mat-block">-->
            <!--                <span matPrefix><i matTooltip="Airbnb exclusive feature" class="fab fa-airbnb"></i></span>-->
            <!--                <input type="text" formControlName="business_tax_id" matInput placeholder="Business Tax Id" />-->
            <!--              </mat-form-field>-->
            <!--            </div>-->
            <!--            <div class="col-sm-4">-->
            <!--              <mat-form-field class="mat-block">-->
            <!--                <span matPrefix><i matTooltip="Airbnb exclusive feature" class="fab fa-airbnb"></i></span>-->
            <!--                <input-->
            <!--                  type="text"-->
            <!--                  formControlName="tot_registration_id"-->
            <!--                  matInput-->
            <!--                  placeholder="Accommodations tax registration number"-->
            <!--                />-->
            <!--              </mat-form-field>-->
            <!--            </div>-->
            <!--            <div class="col-sm-3">-->
            <!--              <mat-form-field class="mat-block">-->
            <!--                <span matPrefix><i matTooltip="Airbnb exclusive feature" class="fab fa-airbnb"></i></span>-->
            <!--                <input-->
            <!--                  type="number"-->
            <!--                  formControlName="long_term_stay_exemption"-->
            <!--                  matInput-->
            <!--                  step="1"-->
            <!--                  placeholder="Long term stay exemption"-->
            <!--                />-->
            <!--              </mat-form-field>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <button (click)="addTax()" class="btn btn-success" type="button">
              <i class="fal fa-plus"></i> <ng-container i18n>Add Tax</ng-container>
            </button>
            <div class="rental-selector-box">
              <span i18n>Copy taxes from:</span>
              <app-select-search
                bindLabel="name"
                floatLabel="never"
                [multiple]="false"
                [items]="rentals$ | async"
                [ctrl]="rentalCtrl"
                class="rental-selector"
                placeholder="Rental"
                i18n-placeholder
              ></app-select-search>
              <button
                [disabled]="!rentalCtrl.value"
                (click)="onCopy(rentalCtrl.value)"
                class="btn btn-success text-uppercase"
                type="button"
              >
                <i class="fal fa-copy"></i>
                <ng-container i18n>Copy</ng-container>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
